  $(document).ready(function(){
  $('[data-testimonials-slider]').slick({
    dots: false,
    // autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    arrows: true,
            prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
            nextArrow:'<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
    responsive: [
      {
        breakpoint: 1200, // breakpoint for desktop screens
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768, // breakpoint for tablet screens
        settings: {
          slidesToShow: 2,
          dots: true
        }
      },
      {
        breakpoint: 576, // breakpoint for mobile screens
        settings: {
          slidesToShow: 2,
          autoplay: true,
          dots: true
        }
      }
    ]
  });
});


